import { render, staticRenderFns } from "./OurVision.vue?vue&type=template&id=1c8c5b20&scoped=true&"
import script from "./OurVision.vue?vue&type=script&lang=ts&"
export * from "./OurVision.vue?vue&type=script&lang=ts&"
import style0 from "./OurVision.vue?vue&type=style&index=0&id=1c8c5b20&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8c5b20",
  null
  
)

export default component.exports